module.exports = __webpack_public_path__ + "img/icon-resta.43191464.svg";